import { eLynxObjectTypeEnum } from "../../../common/enums/eLynxObjectType";
import AlarmSetpointUsageList, { AlarmSetpointUsageListType } from "./AlarmSetpointUsageList";
import TabBar from "../../tab-bar/TabBar";
import TabWithCount from "../../tab-with-count/TabWithCount";
import { AlarmSetpointUsageTabEnum, UseAlarmSetpointUsageStateType } from "./AlarmSetpointUsageState";
import { getObjectTypeName } from "../../../common/utilities/GetObjectTypeName";
import TabContainer from "../../tab-container/TabContainer";
// import { useFormContext, useWatch } from "react-hook-form";
import { /*SetpointFormType,*/ SetpointUsageActions, usageActionItems } from "../AlarmSetpointEditorUtils";
import NoData from "../../no-data/NoData";
import { t } from "i18next";
import { Box, Button, useTheme } from "@mui/material";
import { ViewOptionStateEnum } from "../../contextual-app-bar/ViewOptionStateEnum";
import { ActionMenuItem, BaseActions } from "../../action-menu/ActionMenuItem";
import { isMobile, isTablet } from "react-device-detect";
import { Ref, RefObject, forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { IEditTagSearchResultDeviceDTO } from "../../../services/setpoint-administration-service/Models";


export type AlarmSetpointUsageType = {
    executeAction: (action: SetpointUsageActions | BaseActions) => void;
};


export type AlarmSetpointUsageProps = {
    usageObjects?: IEditTagSearchResultDeviceDTO[];
    openSideSheet?: boolean;
    onCloseSideSheet?: () => void;
    setViewOptionState?: (value: ViewOptionStateEnum) => void;
    setpointUsageState: UseAlarmSetpointUsageStateType;
};

function AlarmSetpointUsage({
    usageObjects,
    openSideSheet,
    onCloseSideSheet,
    setViewOptionState,
    setpointUsageState
}: AlarmSetpointUsageProps, ref: Ref<AlarmSetpointUsageType> | undefined) {


    const theme = useTheme();

    const deviceUsageList = useRef<AlarmSetpointUsageListType>(undefined);
    const tankUsageList = useRef<AlarmSetpointUsageListType>(undefined);
    const wellUsageList = useRef<AlarmSetpointUsageListType>(undefined);
    const tankBatteryUsageList = useRef<AlarmSetpointUsageListType>(undefined);


    useImperativeHandle<unknown, AlarmSetpointUsageType>(
        ref,
        () => ({
            executeAction: executeAction
        })
    );


    // const {
    //     state, 
    //     setActiveTab,
    // } = useAlarmSetpointUsageState();
    const {
        state, 
        setActiveTab,
    } = setpointUsageState;
    


    // const {
    //     //getValues,
    //     //watch,
    //     //trigger,
    //     control,
    //     //reset,
    //     //setValue,
    //     //resetField
    // } = useFormContext<SetpointFormType>();    

    const isPhone = isMobile && !isTablet;


    // const setpointFormData = useWatch({ control: control }) as SetpointFormType;

    // const deviceCount = setpointFormData.devices.filter(o => o.allowSelection).length;
    // const wellCount = setpointFormData.wells.filter(o => o.allowSelection).length;
    // const tankCount = setpointFormData.tanks.filter(o => o.allowSelection).length;
    // const tankBatteryCount = setpointFormData.tankBatteries.filter(o => o.allowSelection).length;

    const devices = usageObjects?.filter(o => o.objectTypeID === eLynxObjectTypeEnum.Device);
    const wells = usageObjects?.filter(o => o.objectTypeID === eLynxObjectTypeEnum.Well);
    const tanks = usageObjects?.filter(o => o.objectTypeID === eLynxObjectTypeEnum.Tank);
    const tankBatteries = usageObjects?.filter(o => o.objectTypeID === eLynxObjectTypeEnum.TankBattery);

    const deviceCount: number = devices?.length ?? 0;
    const wellCount = wells?.length ?? 0;
    const tankCount = tanks?.length ?? 0;
    const tankBatteryCount = tankBatteries?.length ?? 0;

    const count = deviceCount + wellCount + tankCount + tankBatteryCount;

    
    function renderSection(
        name: "deviceTags" | "wellTags" | "tankTags" | "tankBatteryTags",
        objectType: eLynxObjectTypeEnum,
        usageList: IEditTagSearchResultDeviceDTO[] | undefined,
        ref: RefObject<AlarmSetpointUsageListType | undefined>
    ) {
        return (
            <AlarmSetpointUsageList
                ref={ref}
                name={name}
                objectType={objectType}
                visible={true}
                openSideSheet={openSideSheet}
                onCloseSideSheet={onCloseSideSheet}
                setViewOptionState={setViewOptionState}
                setpointUsageState={setpointUsageState}
                usageObjects={usageList}
            />
        )
    }


    function executeAction(action: SetpointUsageActions | BaseActions) {

        switch(state.activeTab) {
            case AlarmSetpointUsageTabEnum.Devices:
                deviceUsageList.current?.executeAction(action);
                break;
            case AlarmSetpointUsageTabEnum.Tanks:
                tankUsageList.current?.executeAction(action);                
                break;

            case AlarmSetpointUsageTabEnum.Wells:
                wellUsageList.current?.executeAction(action);                
                break;

            case AlarmSetpointUsageTabEnum.TankBatteries:
                tankBatteryUsageList.current?.executeAction(action);                
                break;

            default:
                break;
        }
    }

    function onExecuteAction(menuItem: ActionMenuItem) {

        const action = menuItem.action as SetpointUsageActions | BaseActions;
        executeAction(action);
    }

    useEffect(() => {


        if (count > 0 && state.activeTab === AlarmSetpointUsageTabEnum.None) {
            let activeTab = AlarmSetpointUsageTabEnum.Devices;
            if (deviceCount === 0) {
                if (wellCount > 0) {
                    activeTab = AlarmSetpointUsageTabEnum.Wells;
                } else if (tankCount > 0) {
                    activeTab = AlarmSetpointUsageTabEnum.Tanks;
                } else {
                    activeTab = AlarmSetpointUsageTabEnum.TankBatteries;
                }
            }
            setActiveTab(activeTab);
        }
    }, [
        count,
        state.activeTab,
        deviceCount,
        wellCount,
        tankCount,
        tankBatteryCount,
        setActiveTab
    ]);


   return (count > 0 && state.activeTab !== AlarmSetpointUsageTabEnum.None ? <Box
       sx={{
           display: 'flex',
           flexDirection: 'column',
           flex: '1 1 auto',
           overflow: 'hidden',
           position: 'relative'
       }}>

       <TabBar  value={state.activeTab}
           onChange={(_event, value) => setActiveTab(value)}
       >
           {deviceCount > 0 && 
               <TabWithCount label={getObjectTypeName(eLynxObjectTypeEnum.Device, true)} 
               count={deviceCount}
               //countDisabled={activeTab !== SelectColumnsStepTabEnum.DataValues}
               value={AlarmSetpointUsageTabEnum.Devices}
           />
           }

           {wellCount > 0 &&  
           <TabWithCount label={getObjectTypeName(eLynxObjectTypeEnum.Well, true)} 
               count={wellCount}
               //countDisabled={activeTab !== SelectColumnsStepTabEnum.Attributes}
               value={AlarmSetpointUsageTabEnum.Wells}
           />
           }

           {tankCount > 0 && 
           <TabWithCount label={getObjectTypeName(eLynxObjectTypeEnum.Tank, true)} 
               count={tankCount}
               //countDisabled={activeTab !== SelectColumnsStepTabEnum.Attributes}
               value={AlarmSetpointUsageTabEnum.Tanks}
           />
           }

           {tankBatteryCount > 0 && 
           <TabWithCount label={getObjectTypeName(eLynxObjectTypeEnum.TankBattery, true)} 
               count={tankBatteryCount}
               //countDisabled={activeTab !== SelectColumnsStepTabEnum.Attributes}
               value={AlarmSetpointUsageTabEnum.TankBatteries}
           />
           }

       </TabBar>

       {!isPhone ? 
           // NOTE this has to position absolute, othwerwise the Tab component throws errors
           <Box
               sx={{
                   position: 'absolute',
                   top: theme.spacing(1),
                   right: theme.spacing(3)
               }}>

               {usageActionItems.map(o => 
                       <Button key={o.action} onClick={() => onExecuteAction(o)}>
                           {o.label}
                       </Button>
               )}
               {/* <ContextActionMenu
                   hideOptionsAction={true}
                   onExecuteAction={onExecuteAction}
                   actions={usageActionItems} /> */}
           </Box> : null }



       <TabContainer visible={state.activeTab === AlarmSetpointUsageTabEnum.Devices}>
           {renderSection("deviceTags", eLynxObjectTypeEnum.Device, devices, deviceUsageList)}
       </TabContainer>


       <TabContainer visible={state.activeTab === AlarmSetpointUsageTabEnum.Wells}>
           {renderSection("wellTags", eLynxObjectTypeEnum.Well, wells, wellUsageList)}
       </TabContainer>

       <TabContainer visible={state.activeTab === AlarmSetpointUsageTabEnum.Tanks}>
           {renderSection("tankTags", eLynxObjectTypeEnum.Tank, tanks, tankUsageList)}
       </TabContainer>

       <TabContainer visible={state.activeTab === AlarmSetpointUsageTabEnum.TankBatteries}>
           {renderSection("tankBatteryTags", eLynxObjectTypeEnum.TankBattery, tankBatteries, tankBatteryUsageList)}
       </TabContainer>

   </Box> : <Box sx={{
       padding: 1
   }}>
       <NoData text={t('setpointAdmin.nodata.noObjects')} />
   </Box>);
  }


  export default forwardRef(AlarmSetpointUsage);
